import React from 'react'
import {
  Row,
  Col,
  Table,
  Button,
  Form,
  Card,
  Modal,
  Alert
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartShopping, faTrash } from '@fortawesome/free-solid-svg-icons'
import AddShipping from '../AddShipping.js'
import PosQrScanner from './PosQrScanner.js'
import { formatCurrency } from '../../utils/cart.js'

const PosReceiptCard = ({
  theme,
  cartItems,
  totals,
  taxrate,
  onDelete,
  onShippingChange,
  onCancelSale,
  showCheckout,
  onOpenCheckout,
  onCloseCheckout,
  onSaveCheckout,
  receiptMethod,
  onReceiptMethodChange,
  checkoutValidationError,
  qrid,
  onQridChange
}) => (
  <Card
    id='pos-current-sale'
    className='h-100 pos-receipt-card'
    style={{
      backgroundColor: theme.card,
      color: theme.text,
      borderColor: theme.sidebarAccent
    }}
  >
    <Card.Header
      style={{
        backgroundColor: theme.surfaceMuted,
        borderColor: theme.sidebarAccent
      }}
    >
      <div className='d-flex align-items-center justify-content-between'>
        <h4 className='mb-0' style={{ color: theme.text }}>
          Current sale
        </h4>
        <span className='pos-cart-count'>
          <FontAwesomeIcon icon={faCartShopping} aria-hidden='true' />{' '}
          {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}
        </span>
      </div>
    </Card.Header>
    <Card.Body>
      <div className='d-none d-lg-block'>
        <Table
          striped
          bordered
          hover
          responsive='md'
          className='mb-0 table-sm pos-receipt-table'
        >
          <colgroup>
            <col style={{ width: '18%' }} />
            <col style={{ width: '18%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '16%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '18%' }} />
            <col style={{ width: '8%' }} />
          </colgroup>
          <thead>
            <tr>
              <th>Mfg</th>
              <th>Name</th>
              <th>Qty</th>
              <th>Per</th>
              <th>Disc</th>
              <th>Price</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {cartItems.length > 0 ?
              cartItems.map((saleitem) => (
                <tr key={saleitem.id}>
                  <td>{saleitem.manufacturer}</td>
                  <td>{saleitem.subname}</td>
                  <td align='center'>{saleitem.quantity}</td>
                  <td align='right'>{formatCurrency(saleitem.price)}</td>
                  <td align='right'>{saleitem.itemdiscount}%</td>
                  <td align='right'>{formatCurrency(saleitem.lineSubtotal)}</td>
                  <td>
                    <Button
                      type='button'
                      variant='danger'
                      size='sm'
                      aria-label={`Remove ${saleitem.subname} from sale`}
                      onClick={() => onDelete(saleitem.id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </td>
                </tr>
              ))
            : <tr>
                <td colSpan='7' className='text-center'>
                  Add products from the list to build this sale.
                </td>
              </tr>
            }
          </tbody>
        </Table>
      </div>
      <div className='pos-cart-items-mobile d-lg-none'>
        {cartItems.length > 0 ?
          cartItems.map((saleitem) => (
            <article className='pos-cart-item' key={saleitem.id}>
              <div className='pos-cart-item-heading'>
                <div className='pos-cart-item-name'>
                  <span>{saleitem.manufacturer}</span>
                  <strong>{saleitem.subname}</strong>
                </div>
                <Button
                  type='button'
                  variant='outline-danger'
                  className='pos-cart-remove-button'
                  aria-label={`Remove ${saleitem.subname} from sale`}
                  onClick={() => onDelete(saleitem.id)}
                >
                  <FontAwesomeIcon icon={faTrash} aria-hidden='true' />
                  <span>Remove</span>
                </Button>
              </div>
              <dl className='pos-cart-item-details'>
                <div>
                  <dt>Qty</dt>
                  <dd>{saleitem.quantity}</dd>
                </div>
                <div>
                  <dt>Each</dt>
                  <dd>{formatCurrency(saleitem.price)}</dd>
                </div>
                <div>
                  <dt>Discount</dt>
                  <dd>{saleitem.itemdiscount}%</dd>
                </div>
                <div className='pos-cart-item-subtotal'>
                  <dt>Line total</dt>
                  <dd>{formatCurrency(saleitem.lineSubtotal)}</dd>
                </div>
              </dl>
            </article>
          ))
        : <p className='pos-cart-empty mb-0'>
            Add products from the list to build this sale.
          </p>
        }
      </div>
    </Card.Body>
    <Card.Footer>
      <Row>
        <Col>Subtotal</Col>
        <Col align='right'>{formatCurrency(totals.subtotal)}</Col>
      </Row>
      <Row>
        <Col>Disc on sale</Col>
        <Col align='right'>- {formatCurrency(totals.discount)}</Col>
      </Row>
      <Row>
        <Col>
          <AddShipping childToparent={onShippingChange} />
          <hr className='solid' />
        </Col>
        <Col align='right'>{formatCurrency(totals.shipping)}</Col>
      </Row>
      <Row>
        <Col>Tax</Col>
        <Col align='right'>
          {formatCurrency(totals.taxes)} @ {taxrate}%
        </Col>
      </Row>
      <Row className='pos-total-row align-items-center'>
        <Col>
          <strong>Total</strong>
          <small className='d-block'>Including tax and shipping</small>
        </Col>
        <Col className='text-end'>
          <strong className='pos-total-amount'>
            {formatCurrency(totals.total)}
          </strong>
        </Col>
      </Row>
      <div className='pos-receipt-actions'>
        {cartItems.length > 0 && (
          <Button
            className='pos-checkout-button w-100'
            size='lg'
            onClick={onOpenCheckout}
          >
            Continue to checkout
          </Button>
        )}
        <Modal show={showCheckout} onHide={onCloseCheckout}>
          <Modal.Header closeButton>
            <Modal.Title>Complete sale</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className='pos-modal-total'>
              Total due <strong>{formatCurrency(totals.total)}</strong>
            </p>

            <Form.Group className='mb-3'>
              <Form.Label>
                Do you want an electronic or paper receipt?
              </Form.Label>
              <Form.Check
                type='radio'
                name='receipt-method'
                id='receipt-method-electronic'
                label='Electronic receipt'
                checked={receiptMethod === 'electronic'}
                onChange={() => onReceiptMethodChange('electronic')}
              />
              <Form.Check
                type='radio'
                name='receipt-method'
                id='receipt-method-paper'
                label='Paper receipt'
                checked={receiptMethod === 'paper'}
                onChange={() => onReceiptMethodChange('paper')}
              />
            </Form.Group>
            {receiptMethod === 'electronic' && (
              <Form.Group controlId='qrid'>
                <Form.Label>Customer QR code</Form.Label>
                <Form.Control
                  autoFocus
                  type='text'
                  placeholder='Scan or enter a QR code'
                  value={qrid}
                  onChange={(e) => onQridChange(e.target.value)}
                />
                <PosQrScanner onScan={onQridChange} />
              </Form.Group>
            )}
            {receiptMethod === 'paper' && (
              <p className='mb-0'>
                Your browser will open its print dialog after the sale is
                recorded. Choose a connected printer there.
              </p>
            )}
            {checkoutValidationError && (
              <Alert className='mt-3 mb-0' variant='warning' role='alert'>
                {checkoutValidationError}
              </Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='danger' onClick={onCloseCheckout}>
              Cancel
            </Button>
            <Button variant='primary' onClick={onSaveCheckout}>
              Complete sale
            </Button>
          </Modal.Footer>
        </Modal>
        <Button
          type='button'
          variant='outline-danger'
          size='sm'
          onClick={onCancelSale}
        >
          Cancel sale
        </Button>
      </div>
    </Card.Footer>
  </Card>
)

export default PosReceiptCard
